import React, { useState, useEffect, useRef } from "react";

import ChkBox from "components/Custom/ChkBox";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";

const dataJson = require("../gridData.json");

interface defaultProps {
  childRef: any;
  editRows: any[];
}

const Part5 = (props: defaultProps) => {
  const { childRef, editRows } = props;
  const [riskAssesmentCols, setRiskAssesmentColsCols] = useState<any[]>([
    {
      key: "question",
      name: "Question",
      type: "text",
      editable: false,
      width: "65%",
    },
    {
      key: "checkBoxYes",
      name: "YES",
      inputValue: "true",
      type: "radiobutton",
      sortable: true,
      width: "5%",
      className: "textCenter",
    },
    {
      key: "checkBoxNo",
      name: "NO",
      inputValue: "true",
      type: "radiobutton",
      sortable: true,
      width: "5%",
      className: "textCenter",
    },
    {
      key: "comments",
      name: "Comments",
      type: "text",
      editable: true,
      width: "25%",
    },
  ]);

  const tmpRiskAssesmentRows = dataJson["10"]["10.1"];
  const tmpReferenceRows = dataJson["11"]["11.1"];
  for (let key in tmpRiskAssesmentRows) {
    tmpRiskAssesmentRows[key].comments = "";
    tmpRiskAssesmentRows[key].checkBoxYes = "";
    tmpRiskAssesmentRows[key].checkBoxNo = "";
  }
  for (let key in tmpReferenceRows) {
    tmpReferenceRows[key].comments = "";
    tmpReferenceRows[key].checkBoxYes = "";
    tmpReferenceRows[key].checkBoxNo = "";
  }

  const [riskAssesmentRows, setRiskAssesmentRows] =
    useState<any[]>(tmpRiskAssesmentRows);
  const [referenceCols, setReferenceCols] = useState<any[]>([
    {
      key: "question",
      name: "Question",
      type: "text",
      editable: false,
      width: "65%",
    },
    {
      key: "checkBoxYes",
      name: "YES",
      inputValue: "true",
      type: "radiobutton",
      className: "textCenter",
      sortable: true,
      width: "5%",
      renderCell: ({ referenceRows, onRowChange, tabIndex }) => {
        return (
          <div className="excelChkWrapper">
            <ChkBox
              checked={referenceRows.check}
              onChange={(val: any) => {
                onRowChange({
                  ...referenceRows,
                  check: !referenceRows.check,
                });
              }}
            />
          </div>
        );
      },
    },
    {
      key: "checkBoxNo",
      name: "NO",
      inputValue: "true",
      type: "radiobutton",
      className: "textCenter",
      sortable: true,
      width: "5%",
      renderCell: ({ referenceRows, onRowChange, tabIndex }) => {
        return (
          <div className="excelChkWrapper">
            <ChkBox
              checked={referenceRows.check}
              onChange={(val: any) => {
                onRowChange({
                  ...referenceRows,
                  check: !referenceRows.check,
                });
              }}
            />
          </div>
        );
      },
    },
    {
      key: "comments",
      name: "Comments",
      type: "text",
      editable: true,
      width: "25%",
    },
  ]);
  const [referenceRows, setReferenceRows] = useState<any[]>(tmpReferenceRows);

  const grid1Ref: any = useRef();
  const grid2Ref: any = useRef();

  useEffect(() => {
    childRef.saveRecord = saveRecord;
    return () => {
      childRef.saveRecord = null;
    };
  }, []);

  const saveRecord = () => {
    const section1 = grid1Ref.getRowData().map((s1) => {
      return {
        id: s1.id,
        checkBoxYes: s1.checkBoxYes,
        checkBoxNo: s1.checkBoxNo,
        comments: s1.comments,
      };
    });
    const section2 = grid2Ref.getRowData().map((s1) => {
      return {
        id: s1.id,
        checkBoxYes: s1.checkBoxYes,
        checkBoxNo: s1.checkBoxNo,
        comments: s1.comments,
      };
    });
    const items = [...section1, ...section2];
    return { items };
  };

  return (
    <>
      <h4 className="ehsHeading1">{dataJson["10"]["heading1"]}</h4>
      <h5 className="ehsHeading2">{dataJson["10"]["heading2"]}</h5>
      {riskAssesmentRows ? (
        <ExcelGrid
          childRef={grid1Ref}
          cols={riskAssesmentCols}
          rows={riskAssesmentRows}
          noTotalRows={true}
        />
      ) : (
        <div className="pageCenter">
          <Loader />
        </div>
      )}
      <h4 className="ehsHeading1">{dataJson["11"]["heading1"]}</h4>
      <h5 className="ehsHeading2">{dataJson["11"]["heading2"]}</h5>
      {referenceRows ? (
        <ExcelGrid
          childRef={grid2Ref}
          cols={referenceCols}
          rows={referenceRows}
          noTotalRows={true}
        />
      ) : (
        <div className="pageCenter">
          <Loader />
        </div>
      )}
    </>
  );
};

export default Part5;
